export default "__VITE_ASSET__BcpVo3Zq__"